









import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Materials from "@/components/material/Materials.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";
import "github-markdown-css/github-markdown-light.css";
import "highlight.js/styles/vs2015.css";
import VueRouter, { NavigationGuardNext, Route } from "vue-router";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: {
    Header,
    Materials,
  },
})
export default class OContent extends CheckOrganizationAdminLogin {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private get refs(): any {
    return this.$refs;
  }

  private async beforeRouteUpdate(to: Route, from: VueRouter, next: NavigationGuardNext) {
    await this.refs.materials.setMaterial(String(to.query.material));
    await this.refs.materials.setAround(String(to.query.material));
    this.refs.materials.gotoTop();
    await next();
  }
}
